import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { editOrgLoading : true, editOrgMessage: '', editOrgError: false};

export function editOrgState(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_EDIT_ORG:
            return {
                editOrgLoading: true,
                editOrgMessage: '',
                editOrgError: false
            };
        case organisationConstants.RESPONSE_EDIT_ORG:
            return {
                editOrgLoading: false,
                editOrgMessage: action.edited.data,
                editOrgError: false
            }
        case organisationConstants.ERROR_EDIT_ORG:
            return {
                editOrgLoading: false,
                editOrgMessage: action.error.response.data.message !== undefined ? action.error.response.data.message : 'Some error Occured',
                editOrgError: true
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/editOrganisation.reducer.js